import _ from 'lodash';
import {
    Image,
    Space,
    Tag,
    Typography,
} from 'antd';

import { memo } from 'react';
import { BookingType } from '../../types/booking';

interface ProofOfDeliveryProps {
    bookingData: BookingType;
}

const { Title } = Typography;

const ProofOfDelivery = ({ bookingData }: ProofOfDeliveryProps) => {
    const isProofPhotoType = bookingData?.proofOfDeliveryType === 'PHOTO'
        || (!bookingData?.proofOfDeliveryType && !_.isEmpty(bookingData?.proofOfDelivery));
    const isProofCodeType = bookingData?.proofOfDeliveryType === 'CODE'
        || (!bookingData?.proofOfDeliveryType && !_.isEmpty(bookingData?.proofValidationCode));

    if (isProofPhotoType) {
        return bookingData.proofOfDelivery ? (
            <Space direction="vertical" size={8}>
                <Tag color="green">Photo registered</Tag>
                <Image src={bookingData.proofOfDelivery} width={170} height={150} />
            </Space>
        ) : (
            <Tag color="orange">Photo pending</Tag>
        );
    }

    if (isProofCodeType) {
        return bookingData?.proofValidationCode ? (
            <Space direction="vertical" size={8}>
                <Tag color="green">Code registered</Tag>
                <Title level={4} style={{ textAlign: 'center', margin: 0 }}>
                    {`# ${bookingData.proofValidationCode}`}
                </Title>
            </Space>
        ) : (
            <Tag color="orange">Code pending</Tag>
        );
    }

    return <Tag color="orange">Proof of delivery pending</Tag>;
};

export default memo(ProofOfDelivery);
